import { render, staticRenderFns } from "./TemplateChooser.vue?vue&type=template&id=90d8b03e"
import script from "./TemplateChooser.vue?vue&type=script&lang=js"
export * from "./TemplateChooser.vue?vue&type=script&lang=js"
import style0 from "./TemplateChooser.vue?vue&type=style&index=0&id=90d8b03e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports